import { render } from "./OtpPage.vue?vue&type=template&id=0ec9ec66&scoped=true"
import script from "./OtpPage.vue?vue&type=script&lang=js"
export * from "./OtpPage.vue?vue&type=script&lang=js"

import "./OtpPage.vue?vue&type=style&index=0&id=0ec9ec66&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec9ec66"]])

export default __exports__